;(function sampleOrder() {
        function sampleOrder() {
            /**
             * @private
             */
            var _this = this

            /**
             * global cart configuration
             * @type {Object}
             */
            this.config = {}

            /**
             * template Service
             * @property templateService
             * @type {function}
             */
            this.templateService = new window.Creaton.templateService()

            /**
             * cart data service
             * @property cartDataService
             * @type {function}
             */
            this.cartDataService = new window.Creaton.CartDataService()


            /**
             * validate all products in cart if they are still available if not just remove them
             * info: does not affect items which are in cart before this code is deployed see (condition:40)
             */
            this.validateProductColors = function () {
                let cartItems = _this.cartDataService.getCartItems();
                Object.keys(cartItems).forEach(function(colorCode) {
                    const cartItem = cartItems[colorCode];
                    const colorIdentifier = cartItem['color-identifier'] ? cartItem['color-identifier'] : undefined;
                    try {
                        // older cart Items does not have an identifier
                        if (colorIdentifier) {
                            $.post('validate/productColor/'+siteLanguage+'/'+colorIdentifier, (result) => {
                                result = JSON.parse(result);
                                if(result.success === true) {
                                } else {
                                    _this.removeSample(colorCode);
                                    _this.pushSamples()
                                    _this.updateSampleDataHiddenInputField()
                                    $(document).trigger(_this.config.cartEventListener)
                                }
                            })
                        }
                    }
                    catch (error) {
                        console.log(error);
                    }
                });



            }


        /**
         * @method init
         * @returns {undefined}
         */
        this.init = function () {
            _this.config = window.Creaton.Cart.Configuration

                if (_this.isCartFilled()) {
                    if (paywallValidation) _this.validateProductColors();
                    _this.fillOrderSampleTemplate()
                    _this.bindRemoveSample()
                    _this.displaySampleMaxAmountWarning()
                } else {
                    _this.showEmptyCartMessage()
                }

                // "live" check when user is editing the form
                _this.config.$sampleOrderForm.click(function () {
                    _this.displaySampleMaxAmountWarning()
                })
                _this.config.$sampleOrderForm.find('input').change(function () {
                    _this.displaySampleMaxAmountWarning()
                })

                // catch submit event
                _this.config.$sampleOrderForm.submit(function (event) {
                    // prevent submit event
                    if (_this.isTotalAmountOfSamplesReached()) {
                        event.preventDefault()
                        _this.displaySampleMaxAmountWarning()
                        return false
                    }
                    return true
                })
                // regular .on("submit") event handler is not working here cause of the google recapture
            }

            /**
             * checks if cart has items
             *
             * @returns {boolean}
             */
            this.isCartFilled = function () {
                return this.cartDataService.getTotalAmountOfSamples() !== 0
            }

            /**
             * hides the form, if no items are in the cart
             * @return {undefined}
             */
            this.showEmptyCartMessage = function () {
                _this.config.$sampleOrderForm.addClass('hide')
                _this.config.$sampleOrderEmptyCartMessage.addClass('active')
            }

            /**
             * fill the html script template
             * @return {undefined}
             */
            this.fillOrderSampleTemplate = function () {
                $.each(_this.config.cartItems, function (orderCode, item) {
                    _this.fillSampleTemplate(item, orderCode)
                    _this.buildSelectOptionsField(orderCode, item)
                    _this.updateSampleAmount(orderCode, item)
                })

                _this.buildInputField('hidden', JSON.stringify(_this.config.cartItems), _this.config.sampleDataIdentifier)
            }

            /**
             * build a hidden input field for the request
             * with needed sample order JSON data
             *
             * @param type
             * @param value
             * @param name
             *
             * @return {undefined}
             */
            this.buildInputField = function (type, value, name) {
                $('<input>')
                .attr({
                    type: type,
                    value: value,
                    name: '--creaton_product-content_sampleorder[request][' + name + ']',
                })
                .attr(_this.config.sampleOrderInputSampleData, true)
                .appendTo(_this.config.sampleOrderForm)
            }

            /**
             * update the hidden input field's value
             * @return {undefined}
             */

            this.updateSampleDataHiddenInputField = function () {
                $('[' + _this.config.sampleOrderInputSampleData + ']').val(JSON.stringify(_this.config.cartItems))
            }

            /**
             * fill sample select fields with amount options
             *
             * @param orderCode
             * @param item
             */
            this.buildSelectOptionsField = function (orderCode, item) {
                var select = $('[' + _this.config.sampleOrderSelectOrderCode + '="' + orderCode + '"]')
                // remove default empty value
                select.empty()
                for (var i = 1; i <= _this.config.maxSampleAmount; i++) {
                    select.append($('<option></option>').attr('value', i).text(i))
                }
                select.val(item['amount'])
            }

            /**
             * Binding to the sample remove button,
             * which removes the HTML Dom of the sample
             * and also removes the item of the local storage
             *
             * @returns {undefined}
             */
            this.bindRemoveSample = function () {
                $(_this.config.removeSampleItem).bind('click', function () {
                    _this.removeSampleByHtmlElement(this)
                    _this.pushSamples()
                    _this.updateSampleDataHiddenInputField()
                    $(document).trigger(_this.config.cartEventListener)
                })
            }

            /**
             * Listens to an on change event of the amount selects,
             * so it will update the cart and the localStorage
             *
             * @param orderCode
             * @param item
             */
            this.updateSampleAmount = function (orderCode, item) {
                $('[' + _this.config.sampleOrderSelectOrderCode + '="' + orderCode + '"]').change(function () {
                    item['amount'] = parseInt(this.value)
                    _this.config.cartItems[orderCode]['amount'] = item['amount']

                    localStorage.setItem(_this.config.cart, JSON.stringify(_this.config.cartItems))
                    _this.updateSampleDataHiddenInputField()
                    $(document).trigger(_this.config.cartEventListener)
                    _this.displaySampleMaxAmountWarning()
                })
            }

            this.removeSampleByHtmlElement = function (htmlItem) {
                _this.removeSample($(htmlItem).data('order-code'))
            }

            /**
             * remove sample from temp cart object
             * @return {undefined}
             */
            this.removeSample = function (orderCode) {
                delete _this.config.cartItems[orderCode]
                $('[' + _this.config.sampleOrderItemOrderCode + '="' + orderCode + '"]').remove()
                _this.displaySampleMaxAmountWarning()

                if (!_this.isCartFilled()) {
                    _this.showEmptyCartMessage()
                }
            }

            /**
             * update local storage
             * @return {undefined}
             */
            this.pushSamples = function () {
                localStorage.setItem(_this.config.cart, JSON.stringify(_this.config.cartItems))
            }

            /**
             * Handling visibility of the warning message
             * for the user
             *
             * @return {undefined}
             */
            this.displaySampleMaxAmountWarning = function () {
                if (!_this.isTotalAmountOfSamplesReached()) {
                    // everything is ok
                    _this.config.$sampleOrderWarning.removeClass('active')
                    _this.config.$sampleOrderSubmit.removeAttr('disabled')
            } else {
                // prevent user from sending form
                _this.config.$sampleOrderWarning.addClass('active')
                    _this.config.$sampleOrderSubmit.attr('disabled', true)
                }
            }

        /**
         * Checks if the maximum amount has been reached
         *
         * @returns {boolean}
         */
        this.isTotalAmountOfSamplesReached = function () {
            var totalAmountOfSamples = 0

                $.each(_this.config.cartItems, function (i, item) {
                    totalAmountOfSamples = totalAmountOfSamples + item['amount']
                })

                if (totalAmountOfSamples > _this.config.maxSampleAmount) {
                    return true
                }
                return false
            }

            /**
             * fill a html script template
             * is defined at Creaton.Product/Resources/Private/Fusion/Component/CartModal.fusion
             * @param item
             * @param orderCode
             * @return {undefined}
             */
            this.fillSampleTemplate = function (item, orderCode) {
                var templateContent = {
                    '###title###': item['color-title'],
                    '###orderCode###': orderCode,
                    '###link###': item['link'],
                    '###imageUri###': item['image-uri'],
                    '###productTitle###': item['product-title'],
                    '###productCategory###': item['product-category'],
                }

            $(_this.config.sampleOrderOverview).append(
                _this.templateService.getFilledTemplate(_this.config.sampleOrderTemplateContainer, templateContent)
            )
        }



            /**
             * initialize call
             */
            _this.init()
        }

        // define the global scope
        if (!window.Creaton) {
            window.Creaton = {}
        }
        window.Creaton.sampleOrder = sampleOrder
    }

)
()

$(document).ready(function () {
    var $sampleOrder = $("[rel='sample-order-form']")
    if ($sampleOrder.length) {
        new window.Creaton.sampleOrder()
    }
})
